import { Flex } from "@mantine/core";
import type IBlogPost from "@models/IBlog";
import { useEffect, useState } from "react";
import BuyAccountWidget from "../widgets/BuyAccountWidget";
import BuySkinWidget from "../widgets/BuySkinWidget";

interface Props {
  blog?: IBlogPost;
}

const ACCOUNT_WIDGET = "<BuyAccountWidget />";
const SKIN_WIDGET = "<BuySkinWidget />";

const BlogBody: React.FC<Props> = ({ blog }) => {
  const [parts, setParts] = useState<string[]>([]);

  useEffect(() => {
    const content = blog?.body;

    if (content) {
      const contentWithAccountWidgets = content
        .split(ACCOUNT_WIDGET)
        .flatMap((part) => [part, ACCOUNT_WIDGET]);

      if (contentWithAccountWidgets.length > 1) {
        contentWithAccountWidgets.splice(-1, 1);
      }

      const bodyWithSkins = contentWithAccountWidgets.flatMap((part) => {
        if (part === ACCOUNT_WIDGET || part === SKIN_WIDGET) {
          return part;
        }

        const splitText = part.split(SKIN_WIDGET);

        if (splitText.length === 1) {
          return part;
        }

        const addedWidgets = splitText.flatMap((part) => [part, SKIN_WIDGET]);
        addedWidgets.splice(-1, 1);

        return addedWidgets;
      });

      setParts(bodyWithSkins);
    }
  }, [blog?.body]);

  return parts.map((part, i) => {
    if (part === ACCOUNT_WIDGET) {
      return (
        <Flex key={i} className="w-full" justify="center">
          <BuyAccountWidget />
        </Flex>
      );
    }
    if (part === SKIN_WIDGET) {
      return (
        <Flex key={i} className="w-full" justify="center">
          <BuySkinWidget />
        </Flex>
      );
    }

    return (
      <div
        dangerouslySetInnerHTML={{
          __html: part,
        }}
        key={i}
        className="blog-content text-primary-white"
      />
    );
  });
};

export default BlogBody;
